import { mobile } from '../main_trytone';

const calendar = {

    init() {

        // Helpers Base64 <-> JSON (UTF-8 safe)
        const b64EncodeJson = (obj) => btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
        const b64DecodeJson = (b64) => {
            if (!b64) return [];
            try {
                return JSON.parse(decodeURIComponent(escape(atob(b64))));
            } catch {
                return [];
            }
        };

        this.initFilters();
        this.multipleSelect();
        this.loadPopins();
        this.openFilters();

    },
    multipleSelect() {

        $('.multiple-select').each(function () {
            const $select = $(this);

            //if ($select.data('multipleSelect')) return;

            // (éviter double init)
            if ($select.data('ms-initialized')) return;

            // 1) Init du plugin + gestion Lenis sur la dropdown
            $select.multipleSelect({
                hideOptgroupCheckboxes: true,
                selectAll: false,
                onOpen: function () {
                    // "this" = le <select> natif
                    const $s = $(this);
                    const $drop = $s.next('.ms-parent').find('.ms-drop');

                    $drop
                        .attr('data-lenis-prevent-wheel', '')
                        .attr('data-lenis-prevent-touch', '');
                }
            });

            // 2) UI compteur + tags pour CETTE instance
            const $parent = $select.next('.ms-parent');
            const $choiceSpan = $parent.find('.ms-choice > span');

            // conteneur des tags (un par select)
            let $tags = $parent.next('.ms-tags');
            if ($tags.length === 0) {
                $tags = $('<div class="ms-tags"></div>').insertAfter($parent);
            }

            function refreshUI() {
                const values = $select.multipleSelect('getSelects');        // ['1','3',...]
                const texts = $select.multipleSelect('getSelects', 'text'); // ['Chapeau','...']
                const n = values.length;

                // 2.1 Compteur dans le bouton
                const placeholder = $select.attr('data-placeholder') || 'Sélectionner';
                $choiceSpan.text(n === 0 ? placeholder : `${n} item${n > 1 ? 's' : ''}`);

                // 2.2 Tags sous le select
                $tags.empty();
                texts.forEach((label, i) => {
                    const val = values[i];
                    $tags.append(
                        $(
                            `<span class="ms-tag" data-value="${val}">
                        ${label}
                        <button type="button" class="ms-tag-x" aria-label="Retirer">×</button>
                    </span>`
                        )
                    );
                });
            }

            // Clic sur la croix d’un tag => désélectionne dans le plugin
            $tags.on('click', '.ms-tag-x', function () {
                const val = String($(this).closest('.ms-tag').data('value'));
                const left = $select.multipleSelect('getSelects').filter(v => String(v) !== val);
                $select.multipleSelect('setSelects', left);
                refreshUI();
            });

            // Tout changement (clics dans le menu, select/deselect, etc.)
            $select.on('change', refreshUI);

            // 3) Premier rendu + marqueur pour éviter ré-init
            refreshUI();
            $select.data('ms-initialized', true);
        });

        $(document).on('click', '.ms-parent > .ms-choice', function () {
            const $drop = $(this).siblings('.ms-drop');

            if ($drop.length) {
                $drop
                    .attr('data-lenis-prevent-wheel', '')
                    .attr('data-lenis-prevent-touch', '');
            }
        });

    },

    openFilters() {

        $(document).on("click", "._open_filters", function () {
            $(".tt-filters").addClass("_open");
        });
        $(document).on("click", "._close_filters", function () {
            $(".tt-filters").removeClass("_open");
        });

    },


    loadPopins() {
        const $doc = $(document);
        const _SITE_URL = window._SITE_URL || ''; // fallback si non injectée

        // popin ultra simple (singleton)
        let $pop = $('#tt-popin');

        const getRightMargin = () => {
            const vw = $(window).width();

            if (vw <= 650) return 0;
            if (vw >= 1200) return 150;

            // interpolation linéaire entre 650px → 1200px
            const minVW = 650;
            const maxVW = 1200;
            const minMargin = 0;
            const maxMargin = 150;

            return Math.round(
                minMargin + (vw - minVW) * (maxMargin - minMargin) / (maxVW - minVW)
            );
        };


        const positionPopin = ($anchor) => {
            const $pop = $('#tt-popin');
            const W = $(window);
            const margin = 10;
            const marginRight = getRightMargin();

            const vw = W.width();
            const vh = W.height();
            const scrollL = W.scrollLeft();
            const scrollT = W.scrollTop();

            // sécurité : popin visible pour mesurer
            $pop.show();

            let popW = $pop.outerWidth();
            let popH = $pop.outerHeight();

            let left, top;

            // ----- MOBILE : centré, clamp strict -----
            if (vw < 700 || !$anchor || !$anchor.length) {
                left = scrollL + (vw - popW) / 2;
                top  = scrollT + (vh - popH) / 2;
            } else {
                // ----- DESKTOP : ancré -----
                const o = $anchor.offset();
                left = o.left;
                top  = o.top + $anchor.outerHeight() + margin;

                // flip si pas la place en bas
                if (top + popH > scrollT + vh - margin) {
                    top = o.top - popH - margin;
                }
            }

            // ----- CLAMP VIEWPORT (clé) -----
            const minLeft = scrollL + margin;
            const maxLeft = scrollL + vw - popW - marginRight;
            left = Math.min(Math.max(left, minLeft), maxLeft);

            // const minLeft = scrollL + margin;
            // const maxLeft = scrollL + vw - popW - margin;
            // left = Math.min(Math.max(left, minLeft), maxLeft);

            const minTop = scrollT + margin;
            const maxTop = scrollT + vh - popH - margin - 50;
            top = Math.min(Math.max(top, minTop), maxTop);

            // ----- HAUTEUR MAX SI TROP GRAND -----
            const maxHeight = vh - margin * 2;
            if (popH > maxHeight) {
                $pop.css({
                    maxHeight: maxHeight,
                    overflow: 'auto'
                });
            } else {
                $pop.css({
                    maxHeight: '',
                    overflow: ''
                });
            }

            $pop.css({ left, top });
        };


        const hide = () => {
            $pop.hide();
            $("body").removeClass("_no_overflow");
        };

        const show = ($anchor, html, modClass = null) => {
            $pop.removeClass('_w-xs _w-sm _w-md _w-lg');
            $pop.data('_anchor', $anchor);
            if (modClass) $pop.addClass(modClass);

            $pop.find('.__cnt').html(html || '');
            $pop.show();

            if(mobile.state===true){
                $("body").addClass("_no_overflow");
            }

            requestAnimationFrame(() => {
                positionPopin($anchor);
            });
        };


        // const show = ($anchor, html, modClass = null) => {
        //     $pop.removeClass('_w-xs _w-sm _w-md _w-lg');
        //     if (modClass) $pop.addClass(modClass);
        //
        //     $pop.find('.__cnt').html(html || '');
        //     $pop.show();
        //
        //     const W = $(window);
        //     const vw = W.width();
        //
        //     if (vw < 700) {
        //         // centrer dans l'écran
        //         const left = W.scrollLeft() + (vw - $pop.outerWidth()) / 2;
        //         const top = W.scrollTop() + Math.max(16, (W.height() - $pop.outerHeight()) / 2);
        //         $pop.css({left, top});
        //         return;
        //     }
        //
        //     // position ancrée (desktop)
        //     const o = $anchor.offset();
        //     let left = o.left, top = o.top + $anchor.outerHeight() + 8;
        //     const maxLeft = W.scrollLeft() + W.width() - $pop.outerWidth() - 8;
        //     if (left > maxLeft) left = maxLeft;
        //     const maxTop = W.scrollTop() + W.height() - $pop.outerHeight() - 8;
        //     if (top > maxTop) top = o.top - $pop.outerHeight() - 8;
        //     $pop.css({left, top});
        // };


        // --- contenu affiché si .tt-event possède ._no_log
        const renderNoLog = () => `
          <div class="tt-popin-msg">
            <h3 class="_trytone_title _middle">Envie de postuler&nbsp;?</h3>
            <p class="_desc">Vous devez être connecté et avoir l’abonnement pour débloquer l’agenda.</p>
            <a href="${_SITE_URL}connexion" class="_trytone_btn _blue">C’est parti !</a>
          </div>`;

        // --- si salle
        const renderSalleNoLog = () => `
          <div class="tt-popin-msg">
            <h3 class="_trytone_title _middle">Vous ne pouvez accéder au calendrier</h3>
            <p class="_desc">Vous devez être connecté en tant que groupe pour voir le calendrier et postuler.</p>
          </div>`;


        const areAllClosed = ($cell) => {
            const $vis = $cell.find('.tt-event:not(._summary):not(.is-hidden)');
            if (!$vis.length) return false;                    // rien à afficher → pas "tous clos"
            return $vis.filter('.statut_CLOS, .statut_CLOSE').length === $vis.length;
        };

        // 1) Salle prioritaire
        $doc.off('click.tt-ev-salle').on('click.tt-ev-salle', '.tt-event._ctx_salle', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation(); // bloque les autres handlers sur le même event
            const $ev = $(this);
            show($ev, renderSalleNoLog(), '_w-md'); // -> ton popin spécial "salle"
        });


        // Clic direct sur un event verrouillé (pas d'appel AJAX)
        $doc.off('click.tt-ev-nolog')
            .on('click.tt-ev-nolog', '.tt-event._no_log, ._no_log_btn, ._no_subscription', function (e) {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation(); // priorité pour éviter d'autres handlers

                const $target = $(this);

                if ($pop.is(':visible')) {
                    // ✅ On NE re-positionne PAS : on remplace juste le contenu
                    $pop.removeClass('_w-xs _w-sm _w-md _w-lg').addClass('_w-md');
                    $pop.find('.__cnt').html(renderNoLog());
                    return;
                }

                // Popin fermée : on l'ouvre ancrée à l’élément cliqué
                show($target, renderNoLog(), '_w-md');
            });

        // fermer
        $doc.off('click.ttpop-x').on('click.ttpop-x', '#tt-popin .__x', hide);
        $doc.off('click.ttpop-out').on('click.ttpop-out', (e) => {
            if (!$(e.target).closest('#tt-popin, .tt-cell._has-events').length) hide();
        });
        $doc.off('keydown.ttpop-esc').on('keydown.ttpop-esc', (e) => {
            if (e.key === 'Escape') hide();
        });

        // Helper: IDs des events actuellement matchés (cartes sans .is-hidden)
        const getVisibleIds = ($cell) => {
            return $cell.find('.tt-event:not(._summary):not(.is-hidden)')
                .map(function () {
                    return $(this).data('id') || null;
                })
                .get()
                .filter(Boolean);
        };

        // Ouvre la popin pour une cellule donnée (gère 0 / 1 / >1)
        const openCell = ($cell, $anchor) => {

            if ($cell.hasClass('__filtered-empty')) return;
            if ($cell.hasClass('_events_close') || areAllClosed($cell)) return;  // <<< blocage si clos
            const ids = getVisibleIds($cell);

            if (ids.length === 0) {
                show($anchor, '<div class="__item">Aucun événement disponible.</div>');
                return;
            }

            if (ids.length === 1) {
                // 1 seul event (soit jour simple, soit filtrage réduit à 1)
                show($anchor, '<div class="__item">Chargement…</div>');
                $.get(window._SITE_URL + 'get-event', {id: ids[0]})
                    .done((html) => show($anchor, html))
                    .fail(() => show($anchor, '<div class="__item">Erreur de chargement.</div>'));
                return;
            }

            // >1 events → liste via AJAX avec tableau d'IDs
            show($anchor, '<div class="__item">Chargement…</div>');
            $.ajax({
                url: window._SITE_URL + 'get-events',
                method: 'GET',
                data: {'ids[]': ids},     // => ids[]=1&ids[]=2...
            })
                .done((html) => show($anchor, html))
                .fail(() => show($anchor, '<div class="__item">Erreur de chargement.</div>'));
        };

        const repositionPopin = ($anchor) => {
            if (!$anchor || !$anchor.length) return;
            requestAnimationFrame(() => {
                const W = $(window);
                if (W.width() < 700) {
                    const left = W.scrollLeft() + (W.width() - $('#tt-popin').outerWidth()) / 2;
                    const top = W.scrollTop() + Math.max(16, (W.height() - $('#tt-popin').outerHeight()) / 2);
                    $('#tt-popin').css({left, top});
                    return;
                }
                const o = $anchor.offset();
                let left = o.left, top = o.top + $anchor.outerHeight() + 8;
                const maxLeft = W.scrollLeft() + W.width() - $('#tt-popin').outerWidth() - 8;
                if (left > maxLeft) left = maxLeft;
                const maxTop = W.scrollTop() + W.height() - $('#tt-popin').outerHeight() - 8;
                if (top > maxTop) top = o.top - $('#tt-popin').outerHeight() - 8;
                $('#tt-popin').css({left, top});
            });
        };


        // clic sur le bouton “Voir” / overlay (cas multi)
        $doc.off('click.tt-open-day').on('click.tt-open-day', '.tt-day-summary .js-open-day, .tt-day-overlay.js-open-day', function (e) {
            e.preventDefault();
            const $btn = $(this);
            const $cell = $btn.closest('.tt-cell._has-events');
            if (!$cell.length) return;
            if ($cell.hasClass('_events_close') || areAllClosed($cell)) return;  // <<< blocage si clos
            openCell($cell, $btn);
        });


        // clic sur une case (hors bouton/lien explicite)
        // Clic sur cellule (month) OU colonne (week)
        $doc.off('click.tt-calcell').on('click.tt-calcell', '.tt-cell._has-events:not(._events_close), .tt-wcell', function (e) {
            // ignore les vrais boutons/liens
            if ($(e.target).closest('button, a').length) return;


            const $scope = $(this); // .tt-cell (month) ou .tt-wcell (week)

            // 1) Si on a cliqué directement sur un .tt-event "valide", on ouvre le détail unique
            let $ev = $(e.target).closest('.tt-event');
            if (!$ev.length) {
                // ici on regarde VRAIMENT tous les .tt-event de la cellule
                const $events = $scope.find('.tt-event');

                // si la cellule n’en contient qu’un, on le prend par défaut
                if ($events.length === 1) {
                    $ev = $events.eq(0);
                }
            }

            //console.log($ev);

            if ($ev.length) {
                if ($ev.hasClass('_no_log') || $ev.hasClass('_summary') || $ev.hasClass('statut_CLOS') || $ev.hasClass('statut_CLOSE')) return;

                const id = $ev.data('id');
                if (!id) return;

                show($ev, '<div class="__item">Chargement…</div>', '_w-md');
                $.get(window._SITE_URL + 'get-event', {id})
                    .done(html => show($ev, html))
                    .fail(() => show($ev, '<div class="__item">Erreur de chargement.</div>', '_w-md'));
                return;
            }

            // 2) Sinon, on garde le comportement "cellule" (liste ou unique)
            if ($scope.hasClass('_events_close') || areAllClosed($scope)) return;
            openCell($scope, $scope);
        });


        // Dans la popin liste, cliquer sur “Je postule” => affiche le détail (get-event) dans la même popin
        $doc.off('click.tt-postulate').on('click.tt-postulate', '#tt-popin ._open_postulate:not(._no_log_btn)', function (e) {
            e.preventDefault();
            const $btn = $(this);
            const id = $btn.data('event') || $btn.closest('.__event').data('event');
            if (!id) return;

            // NE PAS hide(); on garde la popin ouverte et on swap le contenu
            $.get(window._SITE_URL + 'get-event', {id: id})
                .done((html) => {
                    $pop.find('.__cnt').html(html);
                    requestAnimationFrame(() => positionPopin($pop.data('_anchor')));
                    //repositionPopin($btn);          // <-- recalc ici
                    //setTimeout(() => repositionPopin($btn), 0); // (optionnel) recheck après layout
                })
                .fail(() => {
                    $pop.find('.__cnt').html('<div class="__item">Erreur de chargement.</div>');
                });
        });
    },

    initFilters() {
        var $ = window.jQuery;
        var $selects = $('select._agenda_filter');


        //**************************************************************

        // --- Lien simple departement -> villes ---
        var $selectDepartements = $selects.filter('[data-filter="departement"]');
        var $selectVilles = $selects.filter('[data-filter="villes"]');

        // On garde une copie de TOUTES les options villes d'origine
        var $allVilleOptions = $selectVilles.find('option').clone();

        /**
         * Rebuild du select "villes" en fonction des départements sélectionnés
         * (ne gère QUE la liste des options, tu gères l'affichage / _hide en CSS)
         */
        var syncVilleFilter = function () {
            if (!$selectDepartements.length || !$selectVilles.length) return;

            var selectedDpts = getSelected($selectDepartements); // ex: ["69","75"]
            var hasDpt = selectedDpts.length > 0;

            var $wrapper = $('._filter_villes');
            $wrapper.toggleClass('_hide', !hasDpt);

            // On repart d'un select vide
            $selectVilles.empty();

            // Aucun département → on remet toutes les villes (non sélectionnées)
            if (!hasDpt) {
                // AUCUN département → toutes les villes mais NON cochées
                $allVilleOptions.clone().appendTo($selectVilles);

                if (typeof $selectVilles.multipleSelect === 'function') {
                    $selectVilles.multipleSelect('refresh');
                    $selectVilles.multipleSelect('uncheckAll');
                } else {
                    $selectVilles.val([]);
                }
                return;
            }

            // Au moins un département → on ne garde que les villes qui matchent
            $allVilleOptions.each(function () {
                var $opt = $(this);

                var dptAttr = String($opt.attr('data-dpt') || $opt.attr('data-dpts') || '').trim();
                if (!dptAttr) return;

                var dptList = dptAttr.split(',').map(function (s) {
                    return s.trim();
                }).filter(Boolean);

                var keep = dptList.some(function (d) {
                    return selectedDpts.indexOf(d) !== -1;
                });

                if (keep) {
                    $selectVilles.append($opt.clone());
                }
            });

            // ➜ NOUVELLE PARTIE : cocher toutes les villes visibles
            var allVals = [];
            $selectVilles.find('option').each(function () {
                allVals.push($(this).val());
            });

            if (typeof $selectVilles.multipleSelect === 'function') {
                $selectVilles.multipleSelect('refresh');
                $selectVilles.multipleSelect('setSelects', allVals); // coche tout
            } else {
                $selectVilles.val(allVals);
            }
        };


        //**************************************************************


        // -------- Helpers filtres --------
        var buildFilterDefs = function () {
            var defs = new Map();
            $selects.each(function () {
                var $s = $(this);
                var key = String($s.data('filter') || '').trim();
                if (!key) return;
                var attr = String($s.data('attr') || key).trim();
                var metaAttr = String($s.data('meta') || key).trim();
                var metaKeys = metaAttr.split(',').map(function (s) {
                    return s.trim();
                }).filter(Boolean);

                var mode = String($s.data('mode') || '').trim().toLowerCase();

                if (!mode) {
                    // tous les attributs multi stockés en CSV dans les data-*
                    if (['styles', 'style', 'sonorisation', 'remuneration', 'sets', 'materiel'].indexOf(attr) !== -1) {
                        mode = 'csv';
                    } else if (attr === 'capacite') {
                        mode = 'range';
                    } else {
                        mode = 'single';
                    }
                }

                //if (!mode) mode = (attr === 'styles') ? 'csv' : 'single';
                defs.set(key, {attr: attr, metaKeys: metaKeys, mode: mode});
            });
            return defs;
        };

        var getSelected = function ($s) {
            if (!$s || !$s.length) return [];
            if (typeof $s.multipleSelect === 'function') {
                try {
                    return $s.multipleSelect('getSelects');
                } catch (_) {
                }
            }
            var v = $s.val() || [];
            return Array.prototype.map.call(v, function (x) {
                return String(x);
            });
        };

        var collectSelections = function () {
            var selections = {};
            $selects.each(function () {
                var $s = $(this);
                var key = String($s.data('filter') || '').trim();
                if (!key) return;

                if (key === 'villes') {
                    // Aplatir les data-ids des options sélectionnées → liste d’IDs unique
                    var set = new Set();
                    $s.find('option:selected').each(function () {
                        String($(this).attr('data-ids') || '')
                            .split(',')
                            .forEach(function (id) {
                                id = id.trim();
                                if (id) set.add(id);
                            });
                    });
                    selections[key] = Array.from(set); // ex: ["27686","29914","29906"]
                } else {
                    selections[key] = getSelected($s);
                }
            });
            return selections;
        };


        // Vérifie si une carte DOM correspond à tous les filtres actifs
        var matchesEl = function (el, selections, defs) {
            var keys = Object.keys(selections);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var values = selections[key];
                if (!values || values.length === 0) continue;
                var def = defs.get(key);
                if (!def) continue;

                var raw = String(el.dataset[def.attr] || '').trim();

                if (def.mode === 'csv') {
                    var arr = raw ? raw.split(',').map(function (s) {
                        return s.trim();
                    }).filter(Boolean) : [];
                    var ok = false;
                    for (var j = 0; j < arr.length; j++) {
                        if (values.indexOf(String(arr[j])) !== -1) {
                            ok = true;
                            break;
                        }
                    }
                    if (!ok) return false;
                    continue; // <<<< IMPORTANT : on ne tombe pas dans les autres blocs
                } else if (def.mode === 'range') {
                    var n = parseInt(raw || '0', 10);
                    var okR = false;
                    for (var k = 0; k < values.length; k++) {
                        var tok = String(values[k] || '').trim(); // "200-500" ou "1000-"
                        var parts = tok.split('-');
                        var min = parseInt(parts[0] || '0', 10);
                        var max = (parts.length > 1 && parts[1] !== '') ? parseInt(parts[1], 10) : Infinity;
                        if (!isNaN(n) && n >= min && n <= max) {
                            okR = true;
                            break;
                        }
                    }
                    if (!okR) return false;
                    continue;
                } else {
                    if (!raw || values.indexOf(String(raw)) === -1) return false;
                }
            }
            return true;
        };


        var showWrapper = function (wrapper) {
            if (wrapper) wrapper.style.display = '';
        };
        var hideWrapper = function (wrapper) {
            if (wrapper) wrapper.style.display = 'none';
        };

        // -------- Application des filtres --------
        var applyFilters = function () {
            var defs = buildFilterDefs();
            var selections = collectSelections();
            var hasAny = Object.keys(selections).some(function (k) {
                var v = selections[k];
                return Array.isArray(v) && v.length > 0;
            });

            //console.log(hasAny);

            // Mémo du nombre serveur d'origine (une seule fois)
            Array.prototype.forEach.call(document.querySelectorAll('.tt-agenda .tt-day-summary'), function (s) {
                if (!s.hasAttribute('data-count-orig')) {
                    var c0 = parseInt(s.getAttribute('data-count') || '0', 10);
                    s.setAttribute('data-count-orig', String(c0));
                }
            });


            $.ajax({
                url: window._SITE_URL + 'push-filters',
                method: 'GET',
                data: {'selections': selections}
            });


            // 1) Filtrage carte par carte (DOM)
            var allCards = document.querySelectorAll('.tt-agenda .tt-event:not(._summary)');
            Array.prototype.forEach.call(allCards, function (el) {
                if (!hasAny) {
                    el.classList.remove('is-hidden');
                } else {
                    matchesEl(el, selections, defs) ? el.classList.remove('is-hidden') : el.classList.add('is-hidden');
                }
            });

            // 2) Recompte par cellule et bascule résumé/cartes
            var cells = document.querySelectorAll('.tt-agenda .tt-cell._has-events');
            //console.log(cells);
            Array.prototype.forEach.call(cells, function (cell) {
                var summary = cell.querySelector('.tt-day-summary');
                var wrappers = Array.prototype.slice.call(cell.querySelectorAll('._multi-wrapper'));
                var cards = Array.prototype.slice.call(cell.querySelectorAll('.tt-event:not(._summary)'));

                // aucun filtre → état serveur strict + restauration nombre d'origine
                if (!hasAny) {
                    cell.classList.remove('__filtered-empty');
                    var isMulti = cell.classList.contains('_has-multi-events');
                    if (isMulti) {
                        wrappers.forEach(hideWrapper);
                        if (summary) {
                            summary.classList.remove('is-hidden');
                            var orig = parseInt(summary.getAttribute('data-count-orig') || summary.getAttribute('data-count') || '0', 10);
                            var countNode0 = summary.querySelector('.js-summary-count');
                            if (countNode0) countNode0.textContent = String(orig);
                            var btn0 = summary.querySelector('.js-open-day');
                            if (btn0) btn0.dataset.count = String(orig);
                        }
                    } else {
                        wrappers.forEach(showWrapper);
                        if (summary) summary.classList.add('is-hidden');
                    }
                    return;
                }

                // Filtres actifs → compter les visibles
                var visibleCards = cards.filter(function (c) {
                    return !c.classList.contains('is-hidden');
                });
                var count = visibleCards.length;

                if (count === 0) {
                    cell.classList.add('__filtered-empty');
                    wrappers.forEach(hideWrapper);
                    if (summary) summary.classList.add('is-hidden');
                    return;
                }

                cell.classList.remove('__filtered-empty');

                if (count === 1) {
                    // masquer tout, montrer uniquement le wrapper de la carte visible
                    wrappers.forEach(hideWrapper);
                    var only = visibleCards[0];
                    var wpr = only.closest('._multi-wrapper');
                    if (wpr) showWrapper(wpr);
                    if (summary) summary.classList.add('is-hidden');
                    return;
                }

                // >1 visibles → on masque les cartes et on affiche le résumé avec le bon nombre (sans toucher à data-count d'origine)
                wrappers.forEach(hideWrapper);
                if (summary) {
                    var countNode = summary.querySelector('.js-summary-count');
                    if (countNode) countNode.textContent = String(count);
                    var btn = summary.querySelector('.js-open-day');
                    if (btn) btn.dataset.count = String(count);
                    summary.classList.remove('is-hidden');
                }
            });
        };

        // -------- Interactions --------
        //$selects.on('change', applyFilters);


        $selects.on('change', function () {
            var $s = $(this);

            // Seul le changement sur "departement" impacte les villes
            if ($s.is($selectDepartements)) {
                syncVilleFilter();
            }

            applyFilters();
        });


        var btn = document.getElementById('apply-filters');
        if (btn) btn.addEventListener('click', function (e) {
            e.preventDefault();
            applyFilters();
        });

        // init
        applyFilters();
    }


};

export default calendar;
